import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from '../components/LanguageSwitcher';

export function TermsPage() {
  const { t } = useTranslation();

  const sections = [
    { title: t('termsPage.s1title'), body: t('termsPage.s1body') },
    { title: t('termsPage.s2title'), body: t('termsPage.s2body') },
    { title: t('termsPage.s3title'), body: t('termsPage.s3body') },
    { title: t('termsPage.s4title'), body: t('termsPage.s4body') },
    { title: t('termsPage.s5title'), body: t('termsPage.s5body') },
  ];

  return (
    <div className="min-h-screen p-6 md:p-8 max-w-2xl mx-auto">
      <div className="flex justify-between items-center mb-2">
        <Link to="/settings" className="text-sm text-daynote-muted hover:text-daynote-text">
          {t('termsPage.back')}
        </Link>
        <LanguageSwitcher />
      </div>
      <h1 className="font-display text-4xl mt-6 mb-8">{t('termsPage.title')}</h1>
      <div className="text-sm text-daynote-muted space-y-6 leading-relaxed">
        {sections.map((s) => (
          <section key={s.title}>
            <h2 className="font-display text-lg text-daynote-text mb-2">{s.title}</h2>
            <p>{s.body}</p>
          </section>
        ))}
        <p className="text-xs text-daynote-text/40 pt-4">{t('termsPage.lastUpdated')}</p>
      </div>
    </div>
  );
}
